import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NetDepositView from '../views/NetDepositView';
import { getNetDepositDataRequest } from '../actions';
import { getNetDeposit } from '../selectors';
import {
  DASHBOARD_NET_DEPOSITS_HEADER_FORM,
  DEFAULT_NET_DEPOSIT_SORTING,
  INITIAL_NET_DEPOSITS_FILTERS_VALUES,
} from '../constants';
import { mapNetDepositParamsToRequestPayload } from '../utils/mappers';
import { createPendingSelector } from 'modules/api/selectors';
import { TABLE_CHANGE_EVENT_TYPE } from 'components/TP-UI/TPTable/constants';
import TPLoader from 'components/TP-UI/TPLoader';
import NoDataAvailable from 'modules/common/NoDataAvailable';
import { hasOnlyEmptyValues } from 'utils/hasOnlyEmptyValues';
import clientSorting from 'modules/common/Table/helpers/clientSorting';

const NetDepositContainer = () => {
  const dispatch = useDispatch();
  const [sorting, setSorting] = useState(DEFAULT_NET_DEPOSIT_SORTING);
  const [displayedItems, setDisplayedItems] = useState([]);
  const pending = useSelector(createPendingSelector(getNetDepositDataRequest));
  const netDeposits = useSelector(getNetDeposit);
  const [filterApplied, setFilterApplied] = useState(
    !hasOnlyEmptyValues(INITIAL_NET_DEPOSITS_FILTERS_VALUES),
  );

  useEffect(() => {
    dispatch(
      getNetDepositDataRequest(
        mapNetDepositParamsToRequestPayload(INITIAL_NET_DEPOSITS_FILTERS_VALUES),
      ),
    );
  }, [dispatch]);

  useEffect(() => {
    if (netDeposits) {
      const { sortBy, sortAsc } = sorting;
      const sorted = clientSorting(netDeposits, sortBy, sortAsc);
      setDisplayedItems(sorted);
    }
  }, [netDeposits, sorting]);

  const handleChange = useCallback(
    (data, { type }) => {
      const { sortBy, sortAsc, ...filters } = data;
      //client sorting
      if (type === TABLE_CHANGE_EVENT_TYPE.SORTING) {
        setSorting((val) => ({ ...val, sortBy, sortAsc }));
      } else {
        setFilterApplied(!hasOnlyEmptyValues(filters));
        dispatch(getNetDepositDataRequest(mapNetDepositParamsToRequestPayload(filters)));
      }
    },
    [dispatch],
  );

  return !netDeposits ? (
    <TPLoader />
  ) : netDeposits.length === 0 && !filterApplied && !pending ? (
    <NoDataAvailable />
  ) : (
    <NetDepositView
      items={displayedItems}
      form={DASHBOARD_NET_DEPOSITS_HEADER_FORM}
      sorting={sorting}
      loading={pending}
      onChange={handleChange}
    />
  );
};

export default NetDepositContainer;
